import React from 'react';
import FormikTextField from 'src/components/FormikTextField';
import Label from 'shared/components/label';
import placeholders from 'src/static/placeholders.json';

const AccessOrganizationFields = () => (
  <>
    <Label required>
      Organization Address
      <FormikTextField
        required
        type="text"
        showCheck
        name="address"
        placeholder="e.g. 230 9th St, San Francisco, CA 94103"
        aria-label="Address"
        data-testid="address"
      />
    </Label>
    <Label>
      Organization Website
      <FormikTextField
        required
        type="text"
        showCheck
        name="website"
        placeholder="e.g. www.infinitescholars.org"
        aria-label="Website"
        data-testid="website"
      />
    </Label>
    <Label>
      Organization Phone
      <FormikTextField
        type="text"
        showCheck
        name="phone"
        placeholder={placeholders.tel}
        aria-label="Phone"
        data-testid="phone"
      />
    </Label>
  </>
);

export default AccessOrganizationFields;
